"use strict";
var $ = require("../internals/export");
var $parseInt = require("../internals/number-parse-int");
$({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});
